/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown>, max: NonNullable<unknown> }} Clubs_Chat_CounterInputs */

const en_us2_clubs_chat_counter = /** @type {(inputs: Clubs_Chat_CounterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used}/${i?.max}`)
};

const pt_br2_clubs_chat_counter = /** @type {(inputs: Clubs_Chat_CounterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used}/${i?.max}`)
};

const es_419_clubs_chat_counter = /** @type {(inputs: Clubs_Chat_CounterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used}/${i?.max}`)
};

const pt_pt2_clubs_chat_counter = /** @type {(inputs: Clubs_Chat_CounterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used}/${i?.max}`)
};

const fr_fr2_clubs_chat_counter = /** @type {(inputs: Clubs_Chat_CounterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used}/${i?.max}`)
};

const de_de2_clubs_chat_counter = /** @type {(inputs: Clubs_Chat_CounterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used}/${i?.max}`)
};

const it_it2_clubs_chat_counter = /** @type {(inputs: Clubs_Chat_CounterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used}/${i?.max}`)
};

/**
* | output |
* | --- |
* | "{used}/{max}" |
*
* @param {Clubs_Chat_CounterInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_chat_counter = /** @type {((inputs: Clubs_Chat_CounterInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Chat_CounterInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_chat_counter(inputs)
	if (locale === "es-419") return es_419_clubs_chat_counter(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_chat_counter(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_chat_counter(inputs)
	if (locale === "de-DE") return de_de2_clubs_chat_counter(inputs)
	if (locale === "it-IT") return it_it2_clubs_chat_counter(inputs)
	return en_us2_clubs_chat_counter(inputs)
});
export { clubs_chat_counter as "clubs.chat_counter" }